import { render, staticRenderFns } from "./MedicineSummaryAdditional.vue?vue&type=template&id=2e5c7885"
import script from "./MedicineSummaryAdditional.vue?vue&type=script&lang=js"
export * from "./MedicineSummaryAdditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports